export const GET_TIER_NUMBER_URL = '/flights/GetTierNumber';

export default function ClubCardService(
    $http,
) {
    'ngInject';

    Object.assign(this, {
        getTierNumbers,
        generateGetTierNumbersRequest,
        getTier,
    });

    function generateGetTierNumbersRequest(selectedSeats, flightId) {
        const flightSeats = selectedSeats[flightId];
        if (!flightSeats) {
            return null;
        }

        const transformSeats = (accumulator, seat) => (
            seat.TravellerClubCardId
                ? [
                    ...accumulator,
                    {
                        ClubCardId: seat.TravellerClubCardId,
                        FlightId: flightId,
                    },
                ]
                : accumulator
        );
        const items = Object.values(flightSeats).reduce(transformSeats, []);
        return items.length ? {Items: items} : null;
    }

    function getTierNumbers(request) {
        return $http.apiPOST(GET_TIER_NUMBER_URL, request)
            .then(({data}) => data.Items);
    }

    function getTier(clubCardId, flightId, tierList) {
        const DEFAULT_TIER = '';

        if (!(tierList && tierList.length)) {
            return DEFAULT_TIER;
        }

        const tierListItem = tierList.find(({FlightId, ClubCardId}) =>
            flightId === FlightId && ClubCardId === clubCardId);

        if (!(tierListItem && tierListItem.Tier)) {
            return DEFAULT_TIER;
        }

        return tierListItem.Tier;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/traveller/club-card-service.js